var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExternalArrowIcon = function SvgExternalArrowIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37477 0C0.960555 -4.82905e-05 0.624729 0.335699 0.624681 0.749913C0.624633 1.16413 0.96038 1.49995 1.37459 1.5L4.69837 1.50039L0.25092 5.94783C-0.0419733 6.24073 -0.0419733 6.7156 0.25092 7.00849C0.543813 7.30139 1.01869 7.30139 1.31158 7.00849L5.75906 2.56101L5.75945 5.88485C5.7595 6.29907 6.09532 6.63481 6.50953 6.63477C6.92375 6.63472 7.2595 6.29889 7.25945 5.88468L7.25885 0.750511C7.25883 0.635055 7.23273 0.525694 7.18612 0.428002C7.15861 0.370256 7.12331 0.315299 7.0802 0.264715C7.00716 0.178921 6.91515 0.109783 6.81065 0.0637958C6.7203 0.0240366 6.62062 0.00158242 6.5158 0.000630593L6.50894 0.000599043L1.37477 0Z",
    fill: "#313336"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExternalArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "external-arrow-icon.c208c37b1326ed89b9766ad9369b04a2.svg";